<template lang="pug">
    .Tabs(v-if="items")
        // el-tabs(:value="activeTab")
        //     el-tab-pane(v-for="(item, index) in items" :key="index" :label="item.name" :name="item.path" @click="$emit('click', item)")
        el-menu(:default-active="activeTab" mode="horizontal")
            el-menu-item(
                v-for="(item, index) in items" :key="item.path"
                :class="{ 'with-icon': item.icon && item.icon.name }"
                :index="item.path"
                :router="true"
                @click="$emit('click', item)"
            )
                slot(v-if="item.key" :name="`${item.key}:prefix`")
                span
                    i(v-if="item.icon && item.icon.name" :class="`el-icon-fa-${item.icon.name} ${item.icon.group}`")
                    | {{ getName(item) }}
                slot(v-if="item.key" :name="`${item.key}:suffix`")
        .tabbar-buttons(v-if="hasSlot")
            slot(name="tabbar-buttons")
</template>

<script>
import _ from 'lodash';

export default {
    name: 'Tabs',
    props: {
        items: {
            type: Array,
            required: true
        },
        activeTab: {
            type: String,
            required: false
        },
        customTabLabels: {
            type: Object,
            required: false
        }
    },
    computed: {
        hasSlot() {
            return !!this.$slots['tabbar-buttons'];
        }
    },
    methods: {
        getName(item) {
            const name = item.name;
            const customName = _.get(this.customTabLabels, name);
            return customName || name;
        }
    }
};
</script>

<style lang="sass">

@import '~@/assets/sass/variables'

.Tabs
    display: flex
    .el-menu
        flex-grow: 1
        background: none
        .el-menu-item
            line-height: 1em
            height: auto
            text-decoration: none
            padding: 10px 15px
            display: inline-block
            border-bottom: 1px solid transparent
            margin-bottom: -1px
            &.with-icon
                padding-left: 10px
            &:hover, &:active, &:focus
                background: none !important
                span, i
                    color: $--color-primary
            &.is-active
                border-bottom: 1px solid $--color-primary
                margin-bottom: -1px
                span, i
                    color: $--color-primary
            span, i
                color: $color-grey-text
                transition: color .3s ease
                i
                    font-size: 0.8rem
            // svg
            //     margin-right: 10px
    .tabbar-buttons
        .el-button.is-circle
            width: 32px
            height: 32px
            padding: 0
            font-size: .85rem
            &.delete-button
                margin-right: 20px
</style>
